<template>
    <el-tag size="small" v-if="order.urgent" type="danger">加急</el-tag>
</template>

<script>
    export default {
        name: "UrgentCol",
        props:{
            order:Object
        }
    }
</script>

<style scoped>

</style>